import { useEffect, useState } from "react";
import customerServices from "../../services/CustomerService";
import { Table, Button, Modal } from "antd";
import Lodder from "../../components/Lodder";
const PaymentHistory = () => {
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [showlodder, setShowlodder] = useState(false);
  const [paymentData, setPaymentData] = useState({});
  const [showpaymentDetail, setShowpaymentDetail] = useState(false);
  useEffect(() => {
    setShowlodder(true);
    document.title = "Payment History";
    customerServices
      .GetCustomerPaymentHistory()
      .then((response) => {
        if (response.status) {
          setPaymentHistory(response.resultData);
        }
      })
      .finally(() => {
        setShowlodder(false);
      });
  }, []);
  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (date) => {
        return (
          <>
            {new Date(date).toLocaleDateString("en-US", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </>
        );
      },
    },
    {
      title: "Payment Type",
      dataIndex: "serviceName",
      key: "serviceName",
      sorter: (a, b) => a.serviceName.localeCompare(b.serviceName),
    },
    {
      title: "Business Name",
      dataIndex: "businessName",
      key: "businessName",
      sorter: (a, b) => a.businessName.localeCompare(b.businessName),
    }/* ,
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status - b.status,
      render: (status) => {
        return (
          <>
            {status ? (
              <span className="complete">Completed </span>
            ) : (
              <span className="cancel">Failed</span>
            )}
          </>
        );
      },
    }, */
    ,{
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount - b.amount,
      render: (text, record) => {
        const price = record.amount;
        const formattedAmount = `$${price}.00`;
        return formattedAmount;
      },
    },
  ];
  return (
    <>
      <Lodder show={showlodder} />
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid mt-5 pt-3">
            <div className="row mx-lg-3 mx-0 my-3">
              <div className="col-lg-12">
                <div className="card border-0 shadow card-span w-100">
                  <div className="card-header property-header py-3">
                    <h5 className="mb-0 property-heading-card">
                      PAYMENT HISTORY
                    </h5>
                  </div>
                  <div className="p-4 mt-2 table-responsive">
                    <Table
                      onRow={(record, rowIndex) => {
                        return {
                          onClick: (event) => {
                            setShowpaymentDetail(true);
                            setPaymentData(record);
                          },
                        };
                      }}
                      dataSource={paymentHistory}
                      columns={columns}
                      pagination={{
                        showSizeChanger: true,
                        pageSizeOptions: ["5", "10", "20", "50", "100"],
                        defaultPageSize: 10,
                        total: paymentHistory.length,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        itemRender: (current, type, originalElement) => {
                          if (type === "prev") {
                            return <Button>Previous</Button>;
                          }
                          if (type === "next") {
                            return <Button>Next</Button>;
                          }
                          return originalElement;
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="custom-ant-modal"
        title="Payment Detail"
        visible={showpaymentDetail}
        onCancel={() => {
          setShowpaymentDetail(false);
        }}
        footer={[
          <Button
            className="btn-submit-secondary"
            key="back"
            onClick={() => {
              setShowpaymentDetail(false);
            }}
          >
            CLOSE
          </Button>,
        ]}
      >
        <div className="form-check ps-0 card-span">
          <div className="row">
            <div className="col-lg-3">
              <h6>Name:</h6>
            </div>
            <div className="col-lg-3">
              <span>
                {paymentData.firstName} {paymentData.lastName}
              </span>
            </div>

            <div className="col-lg-3">
              <h6>Legal Tool: </h6>
            </div>
            <div className="col-lg-3">
              <span>{paymentData.serviceName}</span>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3">
              <h6>Amount: </h6>
            </div>
            <div className="col-lg-3">
              <span>${paymentData.amount}.00</span>
            </div>

            <div className="col-lg-3">
              <h6>Date: </h6>
            </div>
            <div className="col-lg-3">
              <span>
                {new Date(paymentData.date).toLocaleDateString("en-US", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </span>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3">
              <h6>Transaction ID: </h6>
            </div>
            <div className="col-lg-9">
              <span>{paymentData.transactionId}</span>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3">
              <h6>Payment ID: </h6>
            </div>
            <div className="col-lg-9">
              <span>{paymentData.paymentId}</span>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3">
              <h6>Payment Status: </h6>
            </div>
            <div className="col-lg-3">
              <span>
                {" "}
                {paymentData.status ? (
                  <span className="complete">Completed </span>
                ) : (
                  <span className="cancel">Failed</span>
                )}
              </span>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default PaymentHistory;
